import { render, staticRenderFns } from "./NotifyConfig.vue?vue&type=template&id=24a94023"
import script from "./NotifyConfig.vue?vue&type=script&lang=js"
export * from "./NotifyConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports